import { useEffect, useState } from "react";
import { Button } from "@/design/components";
import { getEnabledProviders, socialStartUrl, PROVIDER_LABEL, type SocialProvider } from "@/api/oauth";
import styles from "./AuthForm.module.css";

/**
 * "Continue with <provider>" buttons (Phase 7). Renders only the providers the API has
 * actually configured (GET /auth/oauth/providers) — and nothing at all when none are
 * configured or the probe fails, so the email form always stands on its own. A plain
 * effect-fetch (no QueryClient dependency) keeps this droppable into any auth screen.
 * Each button is a full-page navigation to the API origin, which begins the OAuth flow.
 */
export function SocialButtons({ verb = "Continue" }: { verb?: string }) {
  const [providers, setProviders] = useState<SocialProvider[]>([]);

  useEffect(() => {
    const ac = new AbortController();
    getEnabledProviders(ac.signal)
      .then(setProviders)
      .catch(() => {
        /* no providers / probe failed → render nothing (email form stands alone) */
      });
    return () => ac.abort();
  }, []);

  if (providers.length === 0) return null;
  return (
    <div className={styles.social}>
      <div className={styles.socialDivider} aria-hidden="true">
        <span>or</span>
      </div>
      {providers.map((p) => (
        <Button key={p} variant="secondary" fullWidth type="button" onClick={() => window.location.assign(socialStartUrl(p))}>
          {verb} with {PROVIDER_LABEL[p]}
        </Button>
      ))}
    </div>
  );
}
